/* Lumeris : sur ordinateur, ajuste la taille de la photo produit pour que le bas des miniatures
   tombe pile au bas du bouton « Ajouter au panier ». */
(function(){
  var g=document.querySelector('.product.grid'); if(!g) return;
  var busy=false;
  function fit(){
    if(busy) return; busy=true;
    try{
      if(window.innerWidth<990){ g.style.removeProperty('--lm-gw'); return; }
      var mg=g.querySelector('media-gallery'), atc=g.querySelector('.product__info-wrapper .product-form__submit');
      if(!mg||!atc) return;
      for(var k=0;k<4;k++){
        var main=mg.querySelector('.product__media-list'); if(!main) return;
        var th=mg.querySelector('.thumbnail-slider');
        var item=main.querySelector('.product__media-item');
        var top=mg.getBoundingClientRect().top, bottom=atc.getBoundingClientRect().bottom;
        var extra=th&&th.offsetParent?th.getBoundingClientRect().bottom-main.getBoundingClientRect().bottom:0;
        var ratio=item&&item.offsetWidth?item.offsetHeight/item.offsetWidth:1;
        var w=Math.round((bottom-top-extra)/(ratio||1));
        w=Math.max(380,Math.min(760,w));
        var cur=parseInt(g.style.getPropertyValue('--lm-gw'))||0;
        if(Math.abs(cur-w)<=1) break;
        g.style.setProperty('--lm-gw',w+'px');
      }
    } finally { busy=false; }
  }
  var t; function later(){ clearTimeout(t); t=setTimeout(fit,60); }
  fit();
  window.addEventListener('load',fit);
  window.addEventListener('resize',later);
  if('ResizeObserver' in window){ var info=g.querySelector('.product__info-wrapper'); if(info) new ResizeObserver(later).observe(info); }
  document.addEventListener('change',function(e){ if(e.target.closest&&e.target.closest('variant-selects,variant-radios')) later(); });
})();
